//Bookings
// @material-ui/icons
import DateRangeIcon from '@mui/icons-material/DateRange'
import BookingsPage from 'Pages/BookingsPage/BookingsPage/BookingsPage'
import BookingConfirmationPage from '../../Pages/BookingsPage/BookingConfirmationPage/BookingConfirmationPage'
import CreateBookingPageSwitch from '../../Pages/BookingsPage/CreateBookingPage/CreateBookingPageSwitch'
import AuthRoutes from '../../routes/AuthRoutes/authRoutes'
import { getHomeRoutes } from './homeRoutes'
import UserProfileRoutes from './userProfileRoutes'

export function useStandardUserRoutes(user: any, client: any) {
  return [
    ...AuthRoutes,
    ...UserProfileRoutes,

    {
      collapse: true,
      name: 'Bookings',
      rtlName: 'صفحات',
      icon: DateRangeIcon,
      state: 'bookingsCollapse',
      views: [
        {
          path: '/bookings/myBookings',
          navBarHeading: 'Bookings',
          name: 'Bookings',
          rtlName: 'هعذاتسجيل الدخول',
          mini: '',
          rtlMini: '',
          component: BookingsPage,
          layout: '/admin',
        },
        {
          path: '/bookings/create?new=true',
          navBarHeading: 'Bookings',
          name: 'Create New Booking',
          rtlName: 'هعذاتسجيل الدخول',
          mini: '',
          rtlMini: '',
          component: CreateBookingPageSwitch,
          layout: '/admin',
        },
        {
          path: '/bookings/create',
          navBarHeading: 'Bookings',
          name: 'Create Booking',
          component: CreateBookingPageSwitch,
          layout: '/admin',
          redirect: true,
        },
        {
          path: '/bookings/confirmation',
          navBarHeading: 'Booking Confirmation',
          name: 'Booking Confirmation',
          component: BookingConfirmationPage,
          layout: '/admin',
          redirect: true,
        },
      ],
    },
    ...getHomeRoutes(client),
  ]
}
